import { render, staticRenderFns } from "./vinStat.vue?vue&type=template&id=a8f41e32&"
import script from "./vinStat.vue?vue&type=script&lang=js&"
export * from "./vinStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "vinStat.vue"
export default component.exports